// Canonical list of languages the docs are translated into.
//
// Single source of truth: the What's New translation pipeline (`run.js`) and
// the sitemap hreflang wiring (`../sitemap.js`) both consume this list, so the
// set of languages the docs support is declared in exactly one place.
//
// 'en' is the source / default language. Its treatment differs per section:
//   - /new/ materialises English as a path segment: /new/en/<app>/<version>/
//   - /support/ keeps English as the bare canonical URL: /support/<app>/<slug>/
//     (no language segment). Translations are prefixed: /support/<lang>/<app>/<slug>/
//     and x-default points at the bare English URL.

const LANGUAGES = [
  'de',
  'en-gb',
  'en',
  'es',
  'fr',
  'it',
  'ja',
  'ko',
  'pt-br',
  'ru',
  'tr',
  'zh-hans', // zh
  'zh-hant' // zh-TW
]

// Non-English languages. Used to detect the language segment of a translated
// path (e.g. distinguish /support/<lang>/... from the bare /support/<app>/...).
const TRANSLATED_LANGUAGES = LANGUAGES.filter(lang => lang !== 'en')
const TRANSLATED_LANGUAGE_SET = new Set(TRANSLATED_LANGUAGES)

// Support locale for a pathname: a translated /support/<lang>/... path returns
// '<lang>'; English support and every non-support page return 'en'. Shared by
// the SSR <html lang> hook, client route updates, and any locale-aware UI.
const supportLangFromPath = pathname => {
  const parts = String(pathname || '')
    .split('/')
    .filter(Boolean)
  if (parts[0] === 'support' && TRANSLATED_LANGUAGE_SET.has(parts[1]))
    return parts[1]
  return 'en'
}

exports.LANGUAGES = LANGUAGES
exports.supportLangFromPath = supportLangFromPath
exports.LANGUAGE_SET = new Set(LANGUAGES)
exports.TRANSLATED_LANGUAGES = TRANSLATED_LANGUAGES
exports.TRANSLATED_LANGUAGE_SET = TRANSLATED_LANGUAGE_SET
